// src/api/AuthService.js
import axios from 'axios';

// const API_URL = '/api/auth';
const API_URL = process.env.REACT_APP_API_BASE_URL;
console.log("Test Auth", API_URL)
// Configure axios defaults
export const setupAxiosDefaults = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

// Send the saved token from the very first request. Pages fetch data in their own effects,
// which React runs before AuthProvider's checkAuth(), so waiting for it would send the
// first requests anonymously after a page reload. checkAuth() still validates the token.
setupAxiosDefaults(localStorage.getItem('token'));

export const validateToken = async () => {
  try {
    const response = await axios.get(`${API_URL}/auth/validate-token`);
    return response.data;
  } catch (error) {
    console.error('Error validating token:', error);
    throw error;
  }
};

export const login = async (username, password) => {
  try {
    const formData = new FormData();
    formData.append('username', username); // It's email actually
    formData.append('password', password);
    
    const response = await axios.post(`${API_URL}/auth/token`, formData);
    
    // Set auth header for future requests
    setupAxiosDefaults(response.data.access_token);
    
    // Store token in localStorage
    localStorage.setItem('token', response.data.access_token);
    
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const register = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/auth/register`, userData);
    return response.data;
  } catch (error) {
    console.error('Registration error:', error);
    throw error;
  }
};

export const resetPassword = async (currentPassword, newPassword) => {
  try {
    const response = await axios.post(`${API_URL}/auth/reset-password`, {
      current_password: currentPassword,
      new_password: newPassword
    });
    return response.data;
  } catch (error) {
    console.error('Password reset error:', error);
    throw error;
  }
};

export const logout = () => {
  // Remove token from localStorage
  localStorage.removeItem('token');
  
  // Remove auth header
  setupAxiosDefaults(null);
  
  return true;
};

export const checkAuth = async () => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return null;
  }
  
  try {
    // Set default auth header
    setupAxiosDefaults(token);
    
    // Validate token
    const userData = await validateToken();
    
    if (userData.valid) {
      return {
        userId: userData.user_id,
        role: userData.role,
        name: userData.name,
        token
      };
    } else {
      // Clear invalid token
      localStorage.removeItem('token');
      setupAxiosDefaults(null);
      return null;
    }
  } catch (error) {
    // Handle error - clear token
    localStorage.removeItem('token');
    setupAxiosDefaults(null);
    return null;
  }
};